/* eslint-disable import/prefer-default-export */
import { createTheme, lighten } from '@material-ui/core/styles';
// import background from '../assets/img/background/gse.png';
import logo from '../assets/img/logo/letmi.svg';
import MuliFont from '../assets/font/muli_font/Muli-Light.ttf';

const muli = {
  fontFamily: 'Muli-Light',
  fontStyle: 'normal',
  fontDisplay: 'swap',
  fontWeight: 400,
  src: `
    local('Muli-Light'),
    local('Muli-Light'),
    url(${MuliFont}) format('ttf')
  `,
  unicodeRange:
    'U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF',
};

export default createTheme({
  app: {
    favicon: 'letmicert_ico.ico',
    title: 'Licenciamiento - Letmi',
  },
  palette: {
    primary: {
      main: '#0059AD',
      contrastText: '#fff',
    },
    secondary: {
      main: '#0059AD',
    },
    third: {
      main: '#0F0F0F',
    },
    error: {
      main: '#d61103',
    },
  },
  typography: {
    fontFamily: 'Muli, Arial',
    fontSize: 13,
  },
  panelSummary: {
    color: 'white',
    backgroundColor: '#ff6a98',
  },
  resendEmailLink: {},
  verifyEmailLink: {},
  checkOptionFilter: {},
  checkOptionHover: {},
  switchBase: {
    main: '#9e9e9e',
    track: '#fff',
    checked: '#fff',
    selectTrack: '#1D71B8',
  },
  logo,
  styleLogo: {
    zIndex: 1,
    xWidth: 115,
    yHeigh: 40,
  },
  colorHeader: '#163357',
  header: {
    usserLogged: {
      color: '#FFFAEF',
    },
  },
  leftMenu: {
    backgroundColor: '#FFFFFF',
    color: '#0F0F0F',
  },
  home: {
    paquetes: {
      backgroundColor: '#FFFFFF',
    },
    combos: {
      backgroundColor: '#3298CC',
    },
    agregados: {
      backgroundColor: '#F8F8F8',
    },
    backgroundSliderCard: {
      color: 'rgb(255, 255, 255, 0.1)',
    },
    bgColorHead: {
      bases:
        'blue,green,orange,blue,green,orange,blue,green,orange,blue,green,orange',
      combos: 'gray',
      arrayComplementary:
        '1,2,3,4,1,2,3,4,1,2,3,4,1,2,3,4,1,2,3,4,1,2,3,4,1,2,3,4,1,2,3,4,1,2,3,4,1,2,3,4,1,2,3,4,1,2,3,4,1,2,3,4',
      complement: 'red',
      complementaryMyplan: 'blue',
    },
    sliderComboText: {
      color: '#0069A5',
    },
    sliderComplementText: {},
    sliderComplementaryButtonColor: {
      color: 'primary',
    },
    sliderComplementaryButtonTextColor: {
      color: 'primary',
    },
    sliderBackGroundColor: {
      color: '#FFF',
    },
    sliderArrow: {
      color: '#0F0F0F',
    },
    shoppingCart: {
      color: '#FFFFFF',
    },
    cart: {
      dialogTitle: {},
      dialogContent: {},
      title: {
        color: '#E6EEF7',
      },
      tableHead: {
        backgroundColor: '#E6EEF7',
      },
      cardList: {},
      checkIconBox: {
        width: 15,
        height: 15,
        stroke: '#2cc63e',
      },
      listItem: {},
      discountText: {
        color: '#A6A6A6',
      },
      totalText: {
        color: '#003582',
      },
      promoForm: {
        backgroundColor: '#F1F1F1',
        color: '#B2B2B2',
        borderRadius: 5,
      },
      promoFormNoResponsive: {
        backgroundColor: '#F1F1F1',
        color: '#B2B2B2',
        borderRadius: 5,
      },
      slider: {},
      quantityPackage: {},
      quantityPackageResponsive: {},
      dividerMiddle: {},
      listDividerBottom: {},
      listItemPopover: {},
      dividerPopover: {},
      btnPromotional: {
        backgroundColor: '#009BDD',
        color: '#fff',
      },
      tableCell: {
        color: '#fff',
      },
      rowCell: {},
      colorItem: {},
      textPromotional: {
        backgroundColor: '#fff',
      },
      colorTextPromotional: {},
      colorNumberQuantity: {},
      btnContinue: {
        backgroundColor: '#E45501',
        color: '#fff',
        fontSize: 14,
      },
      btnContinueResponsive: {},
      btnAddPackages: {
        backgroundColor: '#fff',
        color: '#1D71B8 !important',
        border: '2px solid #1D71B8 !important',
        float: 'right',
        '&:hover': {
          backgroundColor: '#DBE2E6',
        },
      },
      summaryCart: {
        backgroundColor: '#787878',
      },
      spanResposive: {},
      tableCellNoItems: {},
      subtotalText: {
        color: 'primary',
      },
      btnGoToCart: {
        backgroundColor: 'primary',
      },
      btnRemoveFromCart: {
        color: '#9D9D9D',
      },
      detailPackage: {
        backgroundColor: '#F4F4F4',
      },
      iconShoppingCart: {
        iconShoppingCart: {
          fill: '#CCCCCC',
          '& .b, .c': {
            stroke: '#CCCCCC',
          },
        },
      },
      hoverAddProducts: {
        backgroundColor: '#636363',
      },
      customBadge: {},
      customBadgeItems: 'white',
      helpIconColor: {},
      helpIconColorLicense: {
        color: '#FFFFFF',
      },
      backgroundDialogResponsive: {},
      titleHeader: {},
      deleteIconFromCart: {},
      quantityActionCart: {
        color: '#329FEF',
      },
      typographyCard: {},
      moreLessButton: {
        color: '#2CC63E',
      },
      spacingContent: {},
      itemListStyles: {},
      itemListTextStyle: {
      },
    },
  },
  miplan: {
    bgColorCards: {},
    appBgColorCards: {
      boxShadow: 'none',
    },
    rootCard: {},
    title: {
      color: '#1D71B8',
    },
    subtitle: {
      color: '#6D6E72',
    },
    cardHeader: {
      color: '#003582',
    },
    featureName: {},
    featureValue: {
      color: '#009BDD',
    },
    buttonCard: {
      backgroundColor: '#0059AD',
      color: '#fff',
    },
    hoverButtonCard: {
      color: '#fff',
      backgroundColor: '#06B496',
    },
    iconCard: {
      color: '#009BDD',
    },
    btnDirectPlan: {
      backgroundColor: '#16B1F3',
      color: '#FFFFFF',
      '&:hover': {
        backgroundColor: '#0f7baa',
      },
    },
    circularColor: {
      color: '#FFFFFF',
    },
    tablePlanTable: {
      color: '#FFFFFF',
      backgroundColor: '#009BDD',
      fontWeight: 700,
    },
    tableCellPlanTable: {
      color: '#000000',
      backgroundColor: '#FFFFFF1C',
    },
    purchasedPlans: {
      color: '#009BDD',
      fontWeight: 700,
    },
    plansTypography: {
      color: '#4F4F4F',
      marginLeft: 0,
    },
    spanPlanTable: {
      color: '#E55200',
    },
    reportIcon: {
      color: '#E55200',
    },
  },
  registerForm: {
    masterContainer: {},
    containerForm: {
      expansionPanel: {
        color: '#242121',
      },
    },
    activatePlan: {
      buttonActivate: {
        backgroundColor: '#1D71B8',
        color: '#fff',
      },
      policyAndTerms: {
        color: '#1D71B8',
      },
    },
    btnCancel: {},
    btnCancelNormal: {},
    btnResponsive: {},
    goHomeLink: {},
    titleForm: {},
    contentTextSecondary: {
      main: '#FF6F00',
    },
    typeInput: {
      position: 'relative',
      borderRadius: '4px',
    },
    colorLabelFocus: {},
    colorLabel: '',
    colorInputError: '',
    checkDigit: {
      main: '#FF6F00',
    },
    typeInputValidationCode: {},
    colorLabelValidationCode: '',
    colorBorderNormalValidationCode: {},
    selectIcon: {},
    cashIcon: {
      color: '#FFFFFF',
    },
    creditCardIcon: {
      color: '#FFFFFF',
    },
  },
  statusLicense: {
    containerMessage: {
      backgroundColor: 'white',
    },
    titleStatusLicense: {
      color: '#F4D612',
    },
    summaryOrderPapper: {
      backgroundColor: '#FFFCF8',
    },
    buttonAction: {
      backgroundColor: '#1D71B8',
      color: '#fff',
      '&:hover': {
        backgroundColor: '#004C61',
      },
    },
    appoveLicense: {},
    detailStatus: {
    },
  },
  alertPopup: {
    iconClose: {
      color: '#003582',
    },
    titleAlert: {
      color: '#0F0F0F',
    },
    buttonCancel: {
      backgroundColor: '#003582',
      color: '#fff',
      '&:hover': {
        backgroundColor: '#003582',
      },
    },
    buttonAccept: {
      backgroundColor: '#003582',
      color: '#fff',
      '&:hover': {
        backgroundColor: '#003582',
      },
    },
    secondaryMessageText: {
      color: '#c3c3c3',
    },
    mensajeModalMain: {},
  },
  summaryOrder: {
    loadFiles: {
      backgroundColor: '#F2F4F5',
      color: '#039BDA',
    },
    totalPurchase: {
      color: '#E65705',
    },
    tableCellSummaryOrder: {},
    purchaseSummary: {},
    attachReceiptButtons: {
      color: '#1D71B8',
      borderColor: '#1D71B8',
    },
    textSummaryOrder: {
      '&.MuiTypography-h4': {
        marginLeft: 20,
        fontWeight: 'bold',
      },
    },
    purchaseEmpty: {
      '&.MuiTypography-body1': {
        marginBottom: 10,
        fontWeight: 500,
      },
    },
    formLabelColor: {
      color: 'var(--unnamed-color-575756)',
    },
    linearProgress: {
      backgroundColor: lighten('#FFFFFF', 0.5),
    },
    progressBarBackgroundColor: '#009BDD',
    dividerStyles: {},
    goHome: {},
  },
  backOffice: {
    configurations: {
      title: {
        color: '#003582',
      },
      editIcon: {
        color: '#0059AD',
      },
      package: {
        packageConfiguration: {
          arrayBGColorBase:
            '1,2,3,1,2,3,1,2,3,1,2,3,1,2,3,1,2,3,1,2,3,1,2,3,1,2,3,1,2,3,1,2,3,1,2,3,1,2,3',
          arrayBGColorCombo:
            '1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2',
          arrayBGColorComplementary:
            '1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2',
        },
      },
    },
    contracts: {
      title: {
        color: '#0F0F0F',
      },
      titleForm: {
        color: '#0F0F0F',
      },
      btnSteps: {
        backgroundColor: '#0059AD',
        stepCompleted: '#737373',
      },
      tableProducts: {
        color: '#0F0F0F',
        backgroundColor: '#E6EEF7',
        colorIcon: '#0059AD',
      },
      form: {
        border: '#727276',
        text: '#0F0F0F',
        disabled: '#CECBCC',
      },
      details: {
        text: '#0F0F0F',
        title: '#0F0F0F',
        services: '#0F0F0F',
      },
      searchBar: {
        border: '#0F0F0F',
      },
    },
  },
  helpToolTip: {
    root: {
      backgroundColor: '#94F39B',
      color: '#121212',
    },
  },
  report: {
    mainReport: {
      backgroundColor: '#FFFAEF',
    },
    containerReport: {
      background: 'linear-gradient(#FFFFFFCC, #ffffff)',
    },
    titleReport: {
      color: '#033B85',
      fontSize: 26,
    },
  },
  overrides: {
    MuiButton: {
      root: {
        textTransform: 'none',
      },
      label: {
        fontWeight: 'bold',
      },
    },
    MuiCssBaseline: {
      '@global': {
        body: {
          backgroundColor: '#E8EBEE',
          WebkitBackgroundSize: 'cover',
          MozBackgroundSize: 'cover',
          OBackgroundSize: 'cover',
          backgroundSize: 'cover',
        },
        '@font-face': [muli],
      },
    },
  },
});
